import React, { useState } from 'react';

// Iter 533 (Kamel) — gabarit unique back-office : carte 1 ligne repliée, sobre (gris), mobile d'abord.
// <Repli titre="💶 Total" resume="1 250 € · 12 lignes" testId="x" defaultOpen={false}>…détail…</Repli>
const Repli = ({ titre, resume, children, defaultOpen = false, testId, tone = 'gray', action }) => {
  const [open, setOpen] = useState(defaultOpen);
  const tones = {
    gray: 'border-gray-200 bg-white',
    blue: 'border-sky-200 bg-sky-50/60',
    green: 'border-emerald-200 bg-emerald-50/60',
    amber: 'border-amber-200 bg-amber-50/60',
    red: 'border-red-200 bg-red-50/60',
    violet: 'border-violet-200 bg-violet-50/60',
  };
  return (
    <div className={`rounded-xl border ${tones[tone] || tones.gray}`} data-testid={testId}>
      <div className="flex items-center gap-2 px-2.5 py-1.5">
        <button type="button" onClick={() => setOpen(o => !o)} className="flex-1 min-w-0 text-left flex items-center gap-2" data-testid={testId ? `${testId}-toggle` : undefined}>
          <span className="text-xs font-bold text-[#1E3A5F] truncate min-w-0 max-w-[70%]">{titre}</span>
          {resume && <span className="text-xs text-gray-700 truncate min-w-0" data-testid={testId ? `${testId}-resume` : undefined}>{resume}</span>}
          <span className="ml-auto text-gray-400 text-xs">{open ? '▴' : '▾'}</span>
        </button>
        {action}
      </div>
      {open && <div className="px-2.5 pb-2.5">{children}</div>}
    </div>
  );
};

export default Repli;
